import { useSetAtom } from 'jotai';
import * as profileModule from 'modules/profile';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { popupTransferOrganisationState } from '../PopupTransferOrganisation/PopupTransferOrganisation.states';
import { popupTransferImpossibleState } from './PopupTransferImpossible.states';

export const useTransferImpossiblePopupData = () => {
    const dispatch = useDispatch();

    const toggleTransferPopup = useSetAtom(popupTransferOrganisationState);
    const toggleTransferImpossiblePopup = useSetAtom(popupTransferImpossibleState);

    const onContactSales = useCallback(() => {
        toggleTransferPopup(false);
        toggleTransferImpossiblePopup(false);

        dispatch(profileModule.loadContactSalesPopup());
    }, [dispatch, toggleTransferImpossiblePopup, toggleTransferPopup]);

    return {
        onContactSales,
    };
};
